<template>
  <v-layout row wrap>
    <!-- Dialog -->
    <v-dialog
      v-model="json_data.status"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay="false"
    >
      <v-card style="background-color:#EEEEEE;">
        <v-toolbar dark color="primary">
          <v-tooltip bottom>
            <v-btn slot="activator" icon dark @click="closeDialog">
              <v-icon>close</v-icon>
            </v-btn>
            <span>{{ $t('close') }}</span>
          </v-tooltip>
          <v-toolbar-title>
            <span>
              {{ json_data.save_type == 'create' ? $t('menu.CheckInOutCreate') :
              $t('menu.CheckInOutEdit') }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat dark @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
            <v-icon>save</v-icon>
            <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container background fluid pa-4>
            <v-layout
              row
              wrap
              pa-4
              style="background-color:#fff; margin-top:5px; border-radius:5px;"
            >
              <v-flex xs12>
                <v-form ref="form" v-model="form_valid">
                  <!-- <v-layout row wrap>
                    <v-btn color="#039BE5" dark @click="DownloadExampleExcel()">
                      <span>{{$t('DownloadExample')}}</span>
                    </v-btn>
                    <v-btn class="button-wrapper">
                      <span class="label">{{$t('Upload')}}</span>
                      <input
                        :label="$t('ImportIncome')"
                        type="file"
                        id="file"
                        ref="myFiles"
                        class="upload-box"
                        multiple
                        @change="ImportExcel()"
                        placeholder="Upload File"
                      />
                    </v-btn>
                  </v-layout>-->
                  <v-layout row wrap>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field
                        v-model="form_model.doc_no"
                        :rules="form_rules.doc_no"
                        required
                        :label="$t('doc_no')"
                        append-icon="fas fa-plus-circle"
                        hide-details
                        @click:append="doNewGuid"
                      />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field v-model="form_model.remark" :label="$t('remark')" hide-details />
                    </v-flex>

                    <v-flex md4 sm4 xs12 pa-1 v-if="branch_items.length > 0">
                      <v-select
                        required
                        :items="branch_items"
                        :label="$t('branch')"
                        item-text="name"
                        item-value="code"
                        v-model="branch"
                        hide-details
                        @input="getProfileDepartmentList()"
                      />
                    </v-flex>
                    <v-flex md4 sm4 xs12 pa-1 v-if="branch_items.length > 0">
                      <v-select
                        required
                        :items="department_items"
                        :label="$t('Department')"
                        item-text="name"
                        item-value="code"
                        v-model="department"
                        hide-details
                        @input="getEmployeeList()"
                      />
                    </v-flex>
                    <v-flex md4 sm4 xs12 pa-1>
                      <v-autocomplete
                        :loading="loading"
                        v-model="name"
                        :items="Employee_List"
                        item-text="name"
                        item-value="name"
                        :label="$t('employee_code')"
                        append-icon="search"
                        clearable
                        hide-details
                        required
                        multiple
                        @input="setemp()"
                      >
                      <template slot="selection" slot-scope="{ item, index }">
                      <span v-if="index === 0">{{ item.name }}</span>
                    <span
                      v-if="index === 1"
                      class="grey--text caption"
                    >(+{{ name.length - 1 }} others)</span>
                  </template>
                      <template slot="prepend-item">
                          <v-list-tile ripple @click="toggle" class="checkEmp">
                            <v-list-tile-action>
                              <v-checkbox v-model="isChecked" color="primary"></v-checkbox>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title>Select All</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                        <template slot="append-item">
                          <v-divider class="mb-2"></v-divider>
                        </template></v-autocomplete>
                      <!-- <v-select
                        v-model="name"
                        :items="Employee_List"
                        item-text="name"
                        item-value="name"
                        :label="$t('employee_code')"
                        append-icon="search"
                        clearable
                        hide-details
                        required
                        multiple
                        @input="setemp()"
                      >
                      <template slot="selection" slot-scope="{ item, index }">
                      <span v-if="index === 0">{{ item.name }}</span>
                    <span
                      v-if="index === 1"
                      class="grey--text caption"
                    >(+{{ name.length - 1 }} others)</span>
                  </template>
                      <template slot="prepend-item">
                          <v-list-tile ripple @click="toggle" class="checkEmp">
                            <v-list-tile-action>
                              <v-checkbox v-model="isChecked" color="primary"></v-checkbox>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title>Select All</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                        <template slot="append-item">
                          <v-divider class="mb-2"></v-divider>
                        </template>
                      </v-select> -->
                    </v-flex>
                    <!-- <v-layout row wrap v-for="(items,i) in name" :key="i">
                      <v-flex md6 sm6 xs12 pa-1 v-for="(item, index) in dateTime" :key="index">
                        <v-text-field
                          :label="$t('date')"
                          type="datetime-local"
                          v-model="item.date_time"
                          :rules="form_rules.date_time"
                          hide-details
                        />
                      </v-flex>
                        <v-flex md12 sm12 xs12 py-2>
                        <v-btn color="green" dark @click="_dateTimeControl('plus')">
                          <v-icon size="16" class="px-2">fa-plus</v-icon>
                          <span>{{$t('add')}}</span>
                        </v-btn>
                        <v-btn color="red" dark @click="_dateTimeControl('del')">
                          <v-icon size="16" class="px-2">fa-minus</v-icon>
                          <span>{{$t('remove')}}</span>
                        </v-btn>
                      </v-flex>
                    </v-layout>-->
                    <v-flex md12 sm12 xs12 pa-1>
                      <v-layout row wrap v-for="(items,i) in checkperson" :key="i">
                        <v-flex xs12 pa-2>
                          <span>*ลงเวลา:{{items.id}}</span>
                        </v-flex>
                        <v-flex
                          md6
                          sm6
                          xs12
                          pa-2
                          v-for="(item, index) in items.dateTime"
                          :key="index"
                        >
                          <v-text-field
                            :label="$t('date')"
                            type="datetime-local"
                            v-model="item.date_time"
                            :rules="form_rules.date_time"
                            hide-details
                          />
                        </v-flex>
                        <v-flex md12 sm12 xs12 py-2>
                          <v-btn color="green" dark @click="_dateTimeControl('plus',i)">
                            <v-icon size="16" class="px-2">fa-plus</v-icon>
                            <span>{{$t('add')}}</span>
                          </v-btn>
                          <v-btn color="red" dark @click="_dateTimeControl('del',i)">
                            <v-icon size="16" class="px-2">fa-minus</v-icon>
                            <span>{{$t('remove')}}</span>
                          </v-btn>
                        </v-flex>
                        <v-flex xs12 class="coco-list-divider">
                          <v-divider />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs12 text-xs-right pa-3>
              <v-btn
                color="success"
                @click="json_data.save_type == 'create' ? onSave() : onUpdate()"
              >
                <v-icon>save</v-icon>
                <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>

        <v-card-actions>
          <v-layout row wrap>
            <!-- Show list check in out -->
            <v-flex md12 sm12 xs12>
              <v-layout row wrap v-if="results.length > 0">
                <v-flex
                  md12
                  sm12
                  xs12
                  v-for="(item, index) in CheckInOutData"
                  :key="index"
                  @click="''"
                >
                  <v-card class="coco-box-shadow coco-list-hover">
                    <v-layout
                      align-center
                      justify-center
                      row
                      fill-height
                      wrap
                      class="coco-list-layout"
                    >
                      <v-flex lg1 md1 sm2 xs3 text-xs-center>
                        <v-avatar :size="64">
                          <v-avatar
                            v-if="item.emp_images == '' || item.emp_images == undefined  || item.emp_images == null"
                            :size="64"
                            color="teal"
                          >
                            <span class="white--text headline">{{item.nick_name}}</span>
                          </v-avatar>

                          <Empimage
                            v-if="item.emp_images != '' && item.emp_images != undefined  && item.emp_images != null"
                            :json_data="item.emp_images"
                          />
                        </v-avatar>
                      </v-flex>
                      <v-flex lg9 md9 sm8 xs9>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <span
                              class="coco-list-label-text"
                            >{{isEmpty(item.usercode)? item.usercode : 'emp_code'}}:</span>
                            <span>{{item.first_name}} {{item.last_name}}</span>
                            <span
                              v-html="' (<span style=color:#166BFF;>'+(isEmpty(item.nick_name) ? item.nick_name : 'nick_name')+'</span>)'"
                            />
                          </v-flex>
                          <v-flex xs12 class="hidden-xs-only">
                            <span class="coco-list-label-text hidden-sm-only">
                              {{$t('branch')}}:
                              <span>
                                {{isEmpty(item.branch)? item.branch
                                : 'branch'}}
                              </span>
                            </span>
                            <span class="coco-list-label-text hidden-sm-only">
                              {{$t('Department')}}:
                              <span>
                                {{isEmpty(item.department_name) ?
                                item.department_name : 'department_name'}}
                              </span>
                            </span>
                            <span class="coco-list-label-text hidden-sm-only">
                              {{$t('Position')}}:
                              <span>
                                {{isEmpty(item.position) ?
                                item.position : 'position'}}
                              </span>
                            </span>
                            <span class="coco-list-label-icon">
                              <v-icon>access_time</v-icon>
                              <span>{{formatdate(item.effect_date)}}</span>
                            </span>

                            <span class="coco-list-label-icon">
                              <v-icon>info</v-icon>
                              <span>{{isEmpty(item.name) ? item.name : '-'}}</span>
                            </span>
                          </v-flex>
                          <v-flex xs12 class="hidden-sm-and-up">
                            <span class="coco-list-label-icon">
                              <v-icon style="padding-left: 0px;">access_time</v-icon>
                              <span>{{formatdate(item.effect_date)}}</span>
                            </span>
                            <!-- <span class="coco-list-label-icon">
                              <v-icon>monetization_on</v-icon>
                              <span
                                v-show="currencySymbols == '0'"
                              >{{symbolStyles + ' ' + formatNumber(item.amount, 2, true)}}</span>
                              <span
                                v-show="currencySymbols == '1'"
                              >{{formatNumber(item.amount, 2, true) + ' ' + symbolStyles}}</span>
                            </span>-->
                          </v-flex>
                          <v-flex xs12 class="hidden-sm-and-up">
                            <span class="coco-list-label-icon">
                              <v-icon style="padding-left: 0px;">info</v-icon>
                              <span>{{isEmpty(item.name) ? item.name : '-'}}</span>
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex lg2 md2 sm2 xs2>
                        <v-layout row wrap>
                          <v-flex md12 sm12 xs12 text-xs-center>
                            <v-layout row wrap>
                              <v-flex offset-lg5 offset-md3 lg3 md4 xs6>
                                <v-tooltip bottom>
                                  <v-btn
                                    slot="activator"
                                    color="warning"
                                    icon
                                    flat
                                    @click="EditItem(item,index)"
                                  >
                                    <v-icon>edit</v-icon>
                                  </v-btn>
                                  <span>{{$t('edit')}}</span>
                                </v-tooltip>
                              </v-flex>
                              <v-flex lg3 md4 xs6>
                                <v-tooltip bottom>
                                  <v-btn
                                    slot="activator"
                                    color="error"
                                    icon
                                    flat
                                    @click="deleteItem(item,index)"
                                  >
                                    <v-icon>delete</v-icon>
                                  </v-btn>
                                  <span>{{$t('delete')}}</span>
                                </v-tooltip>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 offset-md1 offset-sm2 class="coco-list-divider">
                        <v-divider />
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn color="#D84315" @click="back()">
                    <v-icon class="mr-2" style="color:#ffffff">fas fa-arrow-left</v-icon>
                    <span style="color:#ffffff">Back</span>
                  </v-btn>
                  <v-btn color="#43A047" @click="dialog = false;onSave()">
                    <v-icon class="mr-2" style="color:#ffffff">save</v-icon>
                    <span style="color:#ffffff">{{$t('save')}}</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Snackbar -->
    <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :color="snack_model.type">
      {{ snack_model.msg }}
      <v-btn dark flat icon @click="snack_model.status = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import Utils from "@/utils/";
import DocumentService from "@/services/DocumentService";
import XLSX from "xlsx";
import moment, { locale } from "moment";
import SettingService from "@/services/SettingService";
import EmployeeService from "@/services/EmployeeService";
export default {
  props: {
    json_data: Object
  },
  watch: {
    json_data(val) {
      this.doNewGuid();
      if (val.data != null) {
        this.form_model = val.data;
        this.getProfileBranchList();
      } else {
        this.$refs.form.resetValidation();
      }
    }
  },
  data: () => ({
    form_valid: false,
    branch: "",
    department: "",
    branch_items: [],
    department_items: [],
    Employee_list: [],
    Employee_items: [],
    json_checkin: [],
    dateTime: [
      {
        date_time: ""
      }
    ],
    form_model: {
      usercode: "",
      doc_no: "",
      remark: "",
      editorCode: localStorage._usercode
    },
    form_rules: {
      date_time: [v => !!v || "do not empty."],
      usercode: [v => !!v || "do not empty."],
      doc_no: [v => !!v || "do not empty."]
    },
    snack_model: {
      status: "",
      msg: "",
      type: ""
    },
    name: [],
    isChecked: false,
    detail_example: [],
    results: [],
    datas: {
      code: "",
      check_in_time: new Date().toISOString().slice(0, 10),
      remark: ""
    },
    CheckInOutData: [],
    form_datas: [],
    checkperson: [
      //0
      // {
      //   id:"",
      //   dateTime:[{
      //      date_time: ""
      //   }]
      // },
      //1
      //checkperson[1].dateTime.push({date_time: ""})
      // {
      //   id:"",
      //   dateTime:[{
      //      date_time: ""
      //   }]
      // },
      //2
      //checkperson[2].dateTime.push({date_time: ""})
      // {
      //   id:"",
      //   dateTime:[{
      //      date_time: ""
      //   }]
      // }
    ]
  }),
  created: function() {
    this.doNewGuid();
    this.getEmployee("newData");
    this.getProfileBranchList();
  },
  computed: {
    ...mapState("filter", ["loading", "Employee_List"]),
    ...mapState("app", [
      "showLoading",
      "formatDates",
      "symbolStyles",
      "currencySymbols"
    ]),
    selectAllEmp() {
      return this.name.length === this.Employee_list.length;
    },
    selectSomeEmp() {
      //console.log(this.name);
      this.checkperson = [];
      this.name.forEach(el => {
        this.checkperson.push({ id: el, dateTime: [] });
      });
      console.log("this", this.checkperson);
      return this.name.length > 0 && !this.selectAllEmp;
    }
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),
    changeStatus(status) {
      this.commitSaveStateType({
        status: status,
        type_name: ""
      });
    },
    setemp() {
      console.log("name:", this.name);
      console.log("checkperson:", this.checkperson);
      let arr = [];
      arr = this.checkperson;
      console.log("arr:", arr);
      this.checkperson = [];

      this.name.forEach(el => {
        this.checkperson.push({ id: el, dateTime: [{ date_time: "" }] });
      });

      if (arr.length > 0) {
        this.checkperson.forEach(element => {
          arr.forEach(el => {
            if (element.id == el.id) {
              element.dateTime = el.dateTime;
            } else {
            }
          });
        });
      }
      console.log("name:", this.name.length);
      console.log("emp:", this.Employee_list.length);
      if (this.Employee_list.length == this.name.length) {
        this.isChecked = true;
      } else {
        this.isChecked = false;
      }
    },
    closeDialog() {
      this.$emit("close-dialog");
      this.clearForm();
      //this.doNewGuid();
    },
    formatdate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formatDate(newDate, format_type) {
      return Utils.formatDate(newDate, format_type);
    },
    formatdateDoc(date) {
      return moment(date).format("DDMMYYYY");
    },

    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    clearForm() {
      this.json_checkin = [];
      this.dateTime = [
        {
          date_time: ""
        }
      ];
      (this.form_model = {
        usercode: "",
        doc_no: "",
        remark: "",
        editorCode: localStorage._usercode
      }),
        (this.checkperson = []);
      this.name = [];
      (this.branch = ""), (this.department = ""), (this.Employee_list = []);
      this.Employee_items = [];
      this.isChecked = false;
      console.log("ddddddddddd", this.checkperson);
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    doNewGuid() {
      this.form_model.doc_no = Utils.newGuid("CO");
    },
    onSave() {
      console.log(this.checkperson.length);
      console.log(this.form_valid.toString());
      if (this.checkperson.length > 0) {
        this.checkperson.forEach(element => {
          element.dateTime.forEach(date => {
            let value = element.id.split(" - ");
            let name = "";
            console.log(value[0] + " : " + value[1]);
            name = value[0];
            if (date.date_time == "" ||(date.date_time == null && this.form_valid.toString() != "true")) {
              date.date_time = null;
              console.log(date.date_time);
              this.showSnackBar("ใส่วันที่และเวลาให้ครบถ้วน", "error");
            }
            if (this.form_valid.toString() == "true") {
              this.json_checkin.push({
                usercode: name,
                doc_no: this.form_model.doc_no,
                remark: this.form_model.remark,
                check_in_time: date.date_time.replace("T", " ") + ":00.0"
              });
              
            
            }
          });
          if(this.form_valid.toString() == "true"){
            console.log("FFFFF", this.json_checkin);
              DocumentService.createCheckinout(this.json_checkin)
                .then(res => {
                  this.showSnackBar("save success", "success");
                  this.closeDialog();
                })
                .catch(err => {
                  this.showSnackBar(err.response.data, "error");
                });
          }
          
        });
      } else { 
        this.showSnackBar("กรุณาเลือกพนักงาน", "error");
      }
    },

    _dateTimeControl(cmd, items) {
      let v = this;
      var temp = [];
      console.log("items", items);
      temp = v.checkperson[items].dateTime;
      console.log(temp);

      if (cmd == "plus") {
        console.log("element", this.checkperson);
        console.log("id", v.checkperson[items].id);
        v.checkperson[items].dateTime.push({ date_time: "" });
      } else {
        if (v.checkperson[items].dateTime.length > 0) {
          v.checkperson[items].dateTime.splice(-1, 1);
        }
      }
      console.log("ddd", this.checkperson);
    },

    DownloadExampleExcel() {
      let v = this;
      console.log("DownloadExampleExcel");
      console.log(v.name);
      v.detail_example.push({
        emp_code: "EMP-001",
        check_in_time: "2019-02-05 18:00:00.000",
        remark: "ลืมสแกน"
      });
      var config = { raw: true, type: "string" };
      var Example = XLSX.utils.json_to_sheet(
        v.detail_example,
        v.head_example,
        config
      );
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, Example, "Example");
      XLSX.writeFile(wb, "ลงเวลา.xlsx");
    },
    ImportExcel() {
      let v = this;
      var config = { raw: true, type: "string" };
      var reader = new FileReader();
      reader.readAsArrayBuffer(this.$refs.myFiles.files[0]);
      reader.onload = function(e) {
        var data = new Uint8Array(reader.result);
        var wb = XLSX.read(data, { type: "array" });
        var firstSheetName = wb.SheetNames[0];
        var worksheet = wb.Sheets[firstSheetName];
        v.results = XLSX.utils.sheet_to_json(worksheet, config);
        console.log(v.results);
        console.log("5555");
        // for (let index = 0; index < v.results.length; index++) {
        //   if (
        //     v.results[index].emp_code != " " &&
        //     v.results[index].check_in_time != " " &&
        //     v.results[index].remark != " "
        //   ) {
        //     v.datas.details.push({
        //       code: v.results[index].emp_code,
        //       check_in_time: v.results[index].check_in_time,
        //       remark: v.results[index].remark,
        //     });
        //   } else {
        //     v.snack_model.status = true;
        //     v.snack_model.msg = "กรุณากรอกข้อมูลให้ครบถ้วน";
        //     v.snack_model.type = "error";
        //   }
        // }
        //console.log(v.datas);
        for (let index = 0; index < v.results.length; index++) {
          v.form_datas.push({
            usercode: v.results[index].emp_code,
            check_in_time: v.results[index].check_in_time,
            remark: v.results[index].remark
          });
        }
        console.log("form_datas");
        console.log(v.form_datas);
        DocumentService.createCheckinout(v.form_datas)
          .then(res => {
            v.CheckInOutData = res.data;
            console.log("CheckDetail");
            console.log(v.CheckInOutData);
          })
          .catch(err => {
            v.snack_model.status = true;
            v.snack_model.msg = "ไม่พบข้อมูล";
            v.snack_model.type = "error";
          });
      };
      reader.onerror = function(e) {
        this.snack_model.status = true;
        this.snack_model.msg = "กรุณากรอกข้อมูลให้ครบถ้วน";
        this.snack_model.type = "error";
      };
    },
    // toggle() {

    //     console.log(this.isChecked);
    //     if (!this.isChecked) {
    //       // this.name = [];
    //       // this.checkperson = [];
    //       this.isChecked = true;
    //     } else {
    //        this.isChecked = false;
    //       // this.name = [];
    //       // this.Employee_List.forEach(data => {
    //       //   this.name.push(data.name);
    //       //   this.checkperson.push({ id: data.name, dateTime: this.dateTime });
    //       // });
    //     }
    //   ;
    // },
    toggle() {
      this.$nextTick(() => {
        console.log(this.selectAllEmp);
        if (this.selectAllEmp) {
          this.name = [];
          this.checkperson = [];
          this.isChecked = false;
        } else {
          this.isChecked = true;
          this.name = [];
          this.checkperson = [];
          this.Employee_list.forEach(data => {
            this.name.push(data.name);
          });

          this.name.forEach(el => {
            this.checkperson.push({ id: el, dateTime: [{ date_time: "" }] });
          });
        }
      });
    },
    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then(res => {
          console.log(res);
          if (res.data.content.length > 0) {
            this.branch_items = res.data.content;
            console.log("eeee", this.branch_items);
          } else {
            console.log("ddddd");
            console.log(this.Employee_List);
            this.Employee_List.forEach(emp => {
              this.Employee_list.push(emp);
            });
            console.log(this.Employee_list);
          }
        })
        .catch(err => {
          console.log(err);

          console.log("ddddd");
          this.Employee_List.forEach(emp => {
            this.Employee_list.push(emp);
          });
          console.log(this.Employee_list);
        });
    },
    getProfileDepartment() {
      SettingService.getProfileDepartmentList()
        .then(res => {
          this.department_items = res.data.content;
          console.log(this.department_items);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProfileDepartmentList() {
      this.department = "";
      SettingService.getDepartmentByBranch(this.branch)
        .then(res => {
          this.department_items = res.data;
          console.log(this.department_items);
          this.getEmployeeList();
        })
        .catch(err => {
          console.log(err);
        });
    },
    getEmployeeList() {
      var position = "";
      var search = "";
      var page = "";
      EmployeeService.getEmployee(
        this.branch,
        this.department,
        position,
        search,
        page
      )
        .then(res => {
          this.Employee_items = res.data.content;
          this.Employee_list = [];
          this.Employee_items.forEach(emp => {
            if (emp.is_active) {
              this.Employee_list.push({
                code: emp.code,
                name: emp.code + " - " + emp.first_name + " " + emp.last_name
              });
            }
          });
          console.log("fff", this.Employee_list);
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style>
.v-input--selection-controls {
  margin-top: 0;
}
.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
  margin-top: 5px;
  margin-right: 15px;
  margin-bottom: 5px;
}

.button-wrapper span.label {
  position: relative;
  display: inline-block;
  width: 100%;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  box-shadow: 0px 2px 2px grey;
}

#file {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.checkEmp .theme--light.v-icon {
  color: #1976d2 !important;
}
.v-card__text {
  padding: 0px !important;
}
</style>